import { AbstractInfoRenderer } from "./AbstractInfoRenderer";
import { optionsForDate } from "../GanttInfoRenderer";
import { Icon } from "semantic-ui-react";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";

export class ProposedTimeSlotInfoRenderer extends AbstractInfoRenderer {

    static defaultProps = {
        entityName: "ProposedTimeSlot"
    }

    renderContent() {
        const { entity } = this.props;
        const ed = entityDescriptors["ProposedTimeSlot"];
        return <div className="flex-container-row flex-center flex-wrap gap3">
            {ed.getField("startTime").renderField(entity, optionsForDate)}
            <div><Icon name="arrow right" /></div>
            {ed.getField("endTime").renderField(entity, optionsForDate)}
            {ed.getField("resource").renderField(entity)}
        </div>
    }
}